module.exports = __webpack_public_path__ + "files/e82286ad4197231d2c6f717f56086c4e.png";